import React from 'react';
const PipeRightAngle2Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="56.25" y1="56.25" x2="112.5" y2="56.25">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <linearGradient id={`${id}_2`} gradientUnits="userSpaceOnUse" x1="56.2505" y1="56.25" x2="56.2505" y2="0">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}_1)`} d="M56.25,112.5h56.25V0L56.25,17.95V112.5z" />
      <path fill={`url(#${id}_2)`} d="M0,56.25V0h112.5L56.25,56.25H0z" />
    </svg>
  );
};
export default PipeRightAngle2Icon;
